import { Theme } from "../../../context/theme/theme.enums";
import { useTheme } from "../../../context/theme";
import { Tile } from "../../reactOL/layers";
import { useOsmSource } from "../useOsmSource";

const OsmTileLayer = () => {
  const { theme } = useTheme();
  const osm = useOsmSource(theme as Theme);
  return <Tile source={osm}></Tile>;
};

export default OsmTileLayer;
